var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaret(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00199 10.5041L8.0012 10.5041C7.9354 10.5045 7.87017 10.4919 7.80925 10.467C7.74858 10.4422 7.69338 10.4057 7.64679 10.3597C7.64659 10.3595 7.6464 10.3593 7.6462 10.3591L3.64765 6.36054C3.55311 6.266 3.5 6.13778 3.5 6.00409C3.5 5.8704 3.55311 5.74218 3.64765 5.64764C3.74218 5.55311 3.8704 5.5 4.00409 5.5C4.13768 5.5 4.26581 5.55303 4.36032 5.64743C4.36039 5.6475 4.36047 5.64757 4.36054 5.64764L7.65 8.94711L8.00355 9.30173L8.35764 8.94764L11.6316 5.67364C11.7254 5.5984 11.8433 5.55935 11.9638 5.56401C12.0897 5.56887 12.2091 5.62103 12.2981 5.71008C12.3871 5.79913 12.4393 5.9185 12.4442 6.04434C12.4488 6.16484 12.4098 6.28277 12.3345 6.37654L8.35199 10.3591C8.35178 10.3593 8.35157 10.3595 8.35136 10.3597C8.25829 10.4517 8.13286 10.5035 8.00199 10.5041Z",
    fill: "black",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaret);
export default __webpack_public_path__ + "static/media/caret.214f8c61f94a80b98be92934e81e9a2e.svg";
export { ForwardRef as ReactComponent };